import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const Faq: FC = () => {
  const { t } = useTranslation("faq");
  const items = t("items", { returnObjects: true }) as {
    title: string;
    description: string;
  }[];
  const itemsHalfLength = Math.ceil(items.length / 2);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Container
      sx={{ position: "relative", pt: { xs: 4, md: 6 }, pb: { xs: 4, md: 12 } }}
    >
      <Stack spacing={{ xs: 4, md: 8 }} alignItems="center">
        <Stack spacing={2} maxWidth={800} sx={{ mx: "auto" }}>
          <Typography
            fontFamily="Epilogue"
            fontSize={40}
            fontWeight={700}
            lineHeight={1.2}
            textAlign="center"
          >
            {t("title")}
          </Typography>
        </Stack>
      </Stack>
      <Grid
        container
        spacing={2}
        sx={{ pt: { xs: 4, md: 12 }, pb: { xs: 4, md: 8 } }}
      >
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            {items.slice(0, itemsHalfLength).map(({ title, description }) => (
              <Box key={title}>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography fontSize={16}>{title}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography
                      fontSize={16}
                      align={isMobile ? "justify" : "left"}
                    >
                      <span dangerouslySetInnerHTML={{ __html: description }} />
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Box>
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            {items
              .slice(itemsHalfLength, items.length)
              .map(({ title, description }) => (
                <Box key={title}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{ justifyContent: isMobile ? "center" : "left" }}
                    >
                      <Typography fontSize={16}>{title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography
                        fontSize={16}
                        align={isMobile ? "justify" : "left"}
                      >
                        <span
                          dangerouslySetInnerHTML={{ __html: description }}
                        />
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              ))}
          </Stack>
        </Grid>
      </Grid>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={1}
      >
        <Typography fontSize={16} align="center">
          {t("need_more_help")}
        </Typography>
        <Box>
          <Button
            component="a"
            href="mailto:help@ebinex.global"
            target="_blank"
            variant="contained"
            size={isMobile ? "medium" : "large"}
          >
            <Typography align="center">{t("button")}</Typography>
          </Button>
        </Box>
      </Stack>
    </Container>
  );
};

export default Faq;
